import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';
import { NavDropdown } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import {
    canAnnounce,
    canManageRegistry,
    canSeeAccounting,
} from '../../../utils/cookies';
import config from '../../../config';

import LanguageSwitcherComponent from '../languageSwitcher/languageSwitcherComponent';

import './headerComponent.css';

import digitlogo from '../../assets/digit.webp';
import '../../assets/scaling-logo.css';

class HeaderComponent extends Component {
    render() {
        return (
            <div className="header-container">
                <Navbar variant="dark" expand="md">
                    <Navbar.Brand href="/member">
                        <img
                            alt="navbar-brand"
                            width="32"
                            height="32"
                            className="d-inline-block align-top rotating-logo"
                            src={digitlogo}
                        />{' '}
                        <p>{this.props.t('common.serviceName')}</p>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse className="justify-content-end">
                        <Nav>
                            {(canAnnounce() ||
                                canManageRegistry() ||
                                canSeeAccounting()) && (
                                <NavDropdown
                                    title={this.props.t('header.admin')}
                                    id="basic-nav-dropdown"
                                >
                                    {canManageRegistry() && (
                                        <NavDropdown.Item href="/admin">
                                            {this.props.t('header.registry')}
                                        </NavDropdown.Item>
                                    )}
                                    {canSeeAccounting() && (
                                        <NavDropdown.Item href="/admin/purchases">
                                            {this.props.t('header.accounting')}
                                        </NavDropdown.Item>
                                    )}
                                    {canAnnounce() && (
                                        <NavDropdown.Item href="/admin/announcements">
                                            {this.props.t('header.adminAnnouncements')}
                                        </NavDropdown.Item>
                                    )}
                                </NavDropdown>
                            )}

                            <Nav.Link href="/announcements">
                                {this.props.t('header.announcements')}
                            </Nav.Link>
                            <Nav.Link href="/member">
                                {this.props.t('header.ownDetails')}
                            </Nav.Link>
                            {config.paymentOptions ? (
                                <Nav.Link href="/member/pay">
                                    {this.props.t('header.shop')}
                                </Nav.Link>
                            ) : null}
                            <Nav.Link href="/logout">
                                {this.props.t('header.logout')}
                            </Nav.Link>
                            <LanguageSwitcherComponent inline />
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        );
    }
}

export default withTranslation()(HeaderComponent);
